import styled from 'styled-components'

export const SelectOverlay = styled.div`
  position: absolute;
  display: none;
  align-items: center;
  justify-content: center;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
` 

export const Container = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  cursor: pointer;

  &:hover {
    ${SelectOverlay} {
      display: flex;
    }
  }
`

export const SelectedContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 23, 42, 0.9);
  border-radius: 8px;
`

export const Image = styled.div<{ src: string }>`
  position: relative;
  width: 100%;
  height: 164px;
  background-color: ${({ theme }) => theme.color.base.c2};
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
`
